import { tw } from "@/utils";
import { useGetTransferInfo } from "./api";

interface TransferInfoProps {
  requestId: string;
}

export const TransferInfo = (props: TransferInfoProps) => {
  const { requestId } = props;

  const { data, isSuccess, isLoading, isError } = useGetTransferInfo(requestId);

  return (
    <div
      className={tw(
        "w-full h-[70px] px-[14px] py-[12px] overflow-auto",
        "border-[1px] border-solid border-gray-g50 rounded-[8px]"
      )}
    >
      {isSuccess && (
        <div className="w-full h-full flex items-center justify-between">
          <div className="shrink-0 w-fit h-fit">
            <div className="text-base font-semibold text-gray-g400 leading-[23px]">
              {data.result.data.managerName}
            </div>
            <div className="mt-[2px] text-sm font-medium text-gray-g300 leading-[14px]">
              {data.result.data.managerPhone ?? "연락처 정보없음"}
            </div>
          </div>
          <div className="flex grow h-full ml-[30px] max-w-[450px] items-center">
            <div className="grow-190 shrink-0">
              <div className={tw(textStyles.ambulanceInfoTitle)}>
                현재 이송차량 위치
              </div>
              <div className={tw(textStyles.ambulanceInfoContent)}>
                {data.result.data.transferPosition
                  ? data.result.data.transferPosition
                  : "정보없음"}
              </div>
            </div>
            <div className="shrink-0 w-[1px] h-full mx-[17px] my-[5px] bg-gray-g30" />
            <div className="grow-80 shrink-0">
              <div className={tw(textStyles.ambulanceInfoTitle)}>
                도착 잔여 시간
              </div>
              <div className={tw(textStyles.ambulanceInfoContent)}>
                {data.result.data.restTime
                  ? `${data.result.data.restTime}분`
                  : "정보없음"}
              </div>
            </div>
            <div className="shrink-0 w-[1px] h-full mx-[17px] my-[5px] bg-gray-g30" />
            <div className="grow-110 shrink-0">
              <div className={tw(textStyles.ambulanceInfoTitle)}>
                남은 거리(km)
              </div>
              <div className={tw(textStyles.ambulanceInfoContent)}>
                {data.result.data.restDistance
                  ? `${data.result.data.restDistance}km`
                  : "정보없음"}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const textStyles = {
  ambulanceInfoTitle: "text-sm font-regular text-gray-g100 leading-[20px]",
  ambulanceInfoContent:
    "mt-[2px] text-base font-medium text-gray-g300 leading-[23px]",
};
